import { combineReducers } from 'redux'

import {
  Addresses,
  BillingAddresses,
  ShippingAddresses,
  SelectedBillingAddressId,
  SelectedShippingAddressId,
  useShippingForBilling,
  disableBillingChanges
} from '../Features/Address/addressReducers'

import {
  PhoneNumber,
  PhoneText,
  completeCheckoutButtonText,
  checkoutEnvironmentMessage
 } from './uiReducers'

import {
  CartItems,
  HasRestrictedItems,
  OrderType
} from '../Features/Cart/cartReducers'

import {
  PaymentOptions,
  SelectedPaymentOptionId,
  PaymentRecord
} from '../Features/PaymentMethod/paymentMethodReducers'

import {
  SubTotal,
  Summary,
  PONumber
} from '../Features/Summary/summaryReducers'

import { isPlaceOrderPending } from '../Features/PlaceOrder/placeOrderReducers'

import {
  ShippingOptions,
  SelectedShippingOptionId,
  isShippingPending
} from '../Features/ShippingMethod/shippingMethodReducers'

import { messages } from '../Features/UserMessaging/userMessagingReducers'

import { CouponCode } from '../Features/Coupon/couponReducers'

import { AnonymousUserEmail } from '../Features/AnonymousUserEmail/anonymousUserEmailReducers'

function OrderNumber(state = 0, action) {
  return state;
}


const entities = combineReducers({
  // Address
  Addresses,
  BillingAddresses,
  SelectedBillingAddressId,
  ShippingAddresses,
  SelectedShippingAddressId,

  // Cart
  CartItems,
  HasRestrictedItems,

  // Payment
  PaymentOptions,
  SelectedPaymentOptionId,
  PaymentRecord,

  // Shipping
  ShippingOptions,
  SelectedShippingOptionId,

  //Summary
  SubTotal,
  Summary,
  OrderNumber,
  
  // Coupon
  CouponCode,

  // Email
  AnonymousUserEmail,

  PONumber,
  
  OrderType
});

const ui = combineReducers({
  // Address
  useShippingForBilling,
  disableBillingChanges,

  // UserMessaging
  messages,

  // PlaceOrder
  isPlaceOrderPending,

  // Shipping
  isShippingPending,

  PhoneNumber,
  PhoneText,
  completeCheckoutButtonText,
  checkoutEnvironmentMessage,
});

function constants(state = {}, action) {
  return state; // they're constants. duh.
};

export const checkoutApp = combineReducers({
  ui,
  entities,
  constants
});



// WEBPACK FOOTER //
// ./src/Components/checkout/GlobalStateContainer/reducers.js